import CohortFilter from './CohortFilter'
export default CohortFilter
